import { trackWebVital } from './utils/analytics';

const reportWebVitals = onPerfEntry => {
  const handler = onPerfEntry instanceof Function ? onPerfEntry : trackWebVital;
  import('web-vitals').then(({ getCLS, getFID, getFCP, getLCP, getTTFB }) => {
    getCLS(handler);
    getFID(handler);
    getFCP(handler);
    getLCP(handler);
    getTTFB(handler);
  });
};

export default reportWebVitals;
